import { render, staticRenderFns } from "./templateContentButtons.vue?vue&type=template&id=20628d47&scoped=true&"
import script from "./templateContentButtons.vue?vue&type=script&lang=ts&"
export * from "./templateContentButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20628d47",
  null
  
)

export default component.exports